<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            flat>
            <v-tabs
              v-model="selected.menu"
              background-color="transparent"
              color="#ff64ad"
              slider-size="5"
              show-arrows
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              dense
              grow
              class="d-flex justify-start tabs-stream">
              <v-tab
                v-for="(item, index) in list"
                :key="index"
                class="px-0 mr-4 d-flex align-center">
                <v-avatar
                  tile
                  size="20">
                  <v-img 
                    contain
                    :src="require(`@/assets/image/service/${item.layanan_kode}.png`)">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          size="20"
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span 
                  class="body-2 text-capitalize ml-2" 
                  :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                  {{ item.layanan_nama }}
                </span>
              </v-tab>
            </v-tabs>

            <div v-if="!process.load && list.length > 0">
              <!-- <Kk v-if="selected.menu === 0"
                :detail="list[selected.menu]" />

              <Ktp v-if="selected.menu === 1"
                :detail="list[selected.menu]" />

              <Kia v-if="selected.menu === 2"
                :detail="list[selected.menu]" />

              <Akl v-if="selected.menu === 3"
                :detail="list[selected.menu]" />
                
              <Akm v-if="selected.menu === 4"
                :detail="list[selected.menu]" />

              <Skp v-if="selected.menu === 5"
                :detail="list[selected.menu]" />

              <Skd v-if="selected.menu === 6"
                :detail="list[selected.menu]" />

              <Upd v-if="selected.menu === 7"
                :detail="list[selected.menu]" />

              <Rkm v-if="selected.menu === 8"
                :detail="list[selected.menu]" /> -->
              
              <Kk v-if="list[selected.menu].layanan_kode === 'KK'"
                :detail="list[selected.menu]" />

              <Ktp v-if="list[selected.menu].layanan_kode === 'KTP'"
                :detail="list[selected.menu]" />

              <Kia v-if="list[selected.menu].layanan_kode === 'KIA'"
                :detail="list[selected.menu]" />

              <Akl v-if="list[selected.menu].layanan_kode === 'AKL'"
                :detail="list[selected.menu]" />
                
              <Akm v-if="list[selected.menu].layanan_kode === 'AKM'"
                :detail="list[selected.menu]" />

              <Skp v-if="list[selected.menu].layanan_kode === 'SKP'"
                :detail="list[selected.menu]" />

              <Skd v-if="list[selected.menu].layanan_kode === 'SKD'"
                :detail="list[selected.menu]" />

              <Upd v-if="list[selected.menu].layanan_kode === 'UPD'"
                :detail="list[selected.menu]" />

              <Rkm v-if="list[selected.menu].layanan_kode === 'RKM'"
                :detail="list[selected.menu]" />
            </div>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        list: [],
        pagination: {},
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Kk: () => import(/* webpackPrefetch: true */ '@/components/submission/kk.vue'),
      Ktp: () => import(/* webpackPrefetch: true */ '@/components/submission/ktp.vue'),
      Kia: () => import(/* webpackPrefetch: true */ '@/components/submission/kia.vue'),
      Akl: () => import(/* webpackPrefetch: true */ '@/components/submission/akl.vue'),
      Akm: () => import(/* webpackPrefetch: true */ '@/components/submission/akm.vue'),
      // Akw: () => import(/* webpackPrefetch: true */ '@/components/submission/akw.vue'),
      // Acr: () => import(/* webpackPrefetch: true */ '@/components/submission/acr.vue'),
      Skp: () => import(/* webpackPrefetch: true */ '@/components/submission/skp.vue'),
      Skd: () => import(/* webpackPrefetch: true */ '@/components/submission/skd.vue'),
      Upd: () => import(/* webpackPrefetch: true */ '@/components/submission/upd.vue'),
      // Kut: () => import(/* webpackPrefetch: true */ '@/components/submission/kut.vue'),
      Rkm: () => import(/* webpackPrefetch: true */ '@/components/submission/rkm.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          order_by: 'ASC',
          list_type: 'short',
          auth_role: 1
        }

        await get('layanan', { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.code === 200) {
            this.list = res.data
            this.pagination = res.pagination

            this.selected.menu = this.$route.query.code === undefined ? 0 : parseInt(this.$route.query.code)
          }
        })
      }
    }
  }
</script>